<template>
    <div>
        <div v-for="(group, index) in groups" :key="index">
            <DestinationList :cruiseType="cruiseType" 
            :subCategory="subCategory"
            :group="group"
            :groupDests1="getGroupDestLists (destinations, group, subCategory)[0]"
            :groupDests2="getGroupDestLists (destinations, group, subCategory)[1]"
            :destinations="destinations"
            :index="index"
            :groupCount="groups.length"
            :groupDests="getGroupDests (destinations, group, subCategory)"
            />
        </div>

    </div>
</template>

<script>
const DestinationList = () => import('@/components/SearchBar/DestinationList')

export default {
    name: 'DestinationGroupForm',
    components: {
        DestinationList
    },
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        subCategory: {
            type: String,
            default: function() {
                return ""
            }
        },
        groups: {
            type: Array,
            default: function() {
                return []
            }
        },
        destinations: {
            type: Array,
            default: function() {
                return []
            }
        },
    },
    data () {
        return {
            cruiseNotAllowTips: "<div><img src='https://resource.rcclchina.com.cn/partner/search-bar-tips.png' /></div>",
        }
    },
    methods: {
        getGroupDests (destinations, group, subGroup) {
            let groupDests = []
            destinations.forEach((destination) => {
                if (destination.cruiseFilterGroupName == group && destination.cruiseFilterGroupSubCategory == subGroup
                && destination.countryName && destination.countryName.length > 0) {
                    groupDests.push(destination)
                }
            })
            return groupDests
        },
        getGroupDestLists (destinations, group, subGroup) {
            const groupDests = this.getGroupDests(destinations, group, subGroup)
            let groupDests1 = []
            let groupDests2 = []
            if (groupDests.length > 12 || group == '南太平洋寻宝之旅') {
                const limit = Math.round(groupDests.length / 2)
                groupDests1 = groupDests.slice(0, limit)
                groupDests2 = groupDests.slice(limit, groupDests.length)
            } else {
                groupDests1 = groupDests
            }

            return [groupDests1, groupDests2]
        },
        isDestinationSameCountry (destinations, group, subGroup) {
            const groupDests = this.getGroupDests(destinations, group, subGroup)
            if (groupDests.length < 2) {
                return false
            }
            let countryName = groupDests[0].countryName
            let isSameCountry = true
            groupDests.forEach((groupDest) => {
                if (countryName != groupDest.countryName) {
                    isSameCountry = false
                }
            })
            return isSameCountry
        }
    },
    computed: {
        hpDestinationTips () {
            return this.cruiseNotAllowTips + "<div class='tip-text'><span>您目前选择的是海外出发航线目的地，暂无法同时选择中国/日本出发航线目的地哦</span></div>"
        },
        rowDestinationTips () {
            return this.cruiseNotAllowTips + "<div class='tip-text'><span>您目前选择的是中国/日本出发航线目的地，暂无法同时选择海外出发航线目的地哦</span></div>"
        },
        hpGroupSubCategories () {
            let groupSubCategories = []
            this.destinations.forEach((filter) => {
                const subCategory = filter.cruiseFilterGroupSubCategory
                if (!groupSubCategories.includes(subCategory)) {
                    groupSubCategories.push(subCategory)
                }
            })

            return groupSubCategories
        }
    }
}
</script>
